import { FC } from "react";
import { Box, HStack, Text } from "@chakra-ui/react";

import { useGetCardsQuery } from "../../../../../api/cards";
import { IScheduleItem } from "../../../../../api/schedule/types.ts";
import { ScheduleItemTextStatus } from "./ScheduleItemTextStatus.tsx";
import { formatDate, getMainPaymentMethod } from "../../../../../utils";

interface Props {
  payment: IScheduleItem;
}

export const ScheduleItemDateWithInfo: FC<Props> = ({ payment }) => {
  const { data } = useGetCardsQuery();

  const formattedDate = payment.date ? formatDate(new Date(payment.date)) : "";
  const isPaymentMethodExist = !!getMainPaymentMethod(data);

  return (
    <Box ml="10px">
      <HStack spacing={1}>
        <Text
          w="82px"
          mt="2px"
          variant="brand"
          fontFamily="Normalidad Medium Var"
          fontWeight="bold"
          fontSize="sm"
          lineHeight="20px"
        >
          {formattedDate}
        </Text>

        <ScheduleItemTextStatus payment={payment} />
      </HStack>

      {payment.status === "PLANNED" && isPaymentMethodExist && (
        <Text fontSize="xs" lineHeight="16px" variant="gray">
          Спишем автоматически в этот день
        </Text>
      )}
    </Box>
  );
};
